import { render, staticRenderFns } from "./banquet.vue?vue&type=template&id=1c13b9de&scoped=true&"
import script from "./banquet.vue?vue&type=script&lang=js&"
export * from "./banquet.vue?vue&type=script&lang=js&"
import style0 from "./banquet.vue?vue&type=style&index=0&id=1c13b9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c13b9de",
  null
  
)

export default component.exports